import type { JsonObject } from "@/api";

// 지표별로 "어떤 config 가 이 값에 영향을 주는지" 안내하는 문구. 실제 제출 overrides 값을 문장에
// 넣어 사용자가 자기 세션의 설정으로 읽게 한다. override 가 없으면 repo config 기본값을 썼다는
// 뜻이므로 "기본값"으로 표기한다. 등록되지 않은 지표는 안내 없이 그린다.

type InfluenceNote = (value: (key: string) => string) => string;

const influenceByMetric: Record<string, InfluenceNote[]> = {
  training_loss: [
    (v) =>
      `배치 크기(train.batch_size = ${v("train.batch_size")})와 학습률(train.optimizer_params.default.lr = ${v("train.optimizer_params.default.lr")})이 스텝당 손실의 크기와 변동 폭에 영향을 줍니다.`,
  ],
  validation_loss: [
    (v) =>
      `기록 단위는 train.budget.unit(현재 ${v("train.budget.unit")})을 따르고, 총 Training 예산은 train.budget.total(현재 ${v("train.budget.total")})입니다.`,
    (v) =>
      `Checkpoint는 train.checkpoint_every_n_epochs(현재 ${v("train.checkpoint_every_n_epochs")}, 기본 5)에폭마다 저장됩니다. 차트의 세로선이 저장 시점입니다.`,
  ],
  epoch_time: [
    (v) =>
      `배치 크기(train.batch_size = ${v("train.batch_size")})와 데이터 로더 워커 수(train.num_workers = ${v("train.num_workers")})가 에폭당 소요 시간에 영향을 줍니다.`,
  ],
};

// validation_status_accuracy 계열은 같은 안내를 공유한다. 상태 분류 헤드의 검증 지표라서 검증
// 주기(budget unit)의 영향만 안내한다.
const statusAccuracyNote: InfluenceNote = (v) =>
  `상태 분류 헤드의 검증 지표입니다. 기록 단위는 train.budget.unit(현재 ${v("train.budget.unit")})을 따릅니다.`;

function overrideLabel(overrides: JsonObject | null, key: string): string {
  const raw = overrides?.[key];
  if (raw === undefined || raw === null) {
    return "기본값";
  }
  return typeof raw === "object" ? JSON.stringify(raw) : String(raw);
}

// 지표 key → 안내 문장 목록. 문장이 없으면 빈 배열이다(ⓘ 미표시).
export function metricInfluenceNotes(metricKey: string, overrides: JsonObject | null): string[] {
  const notes =
    influenceByMetric[metricKey] ??
    (metricKey.startsWith("validation_status_accuracy") ? [statusAccuracyNote] : []);
  return notes.map((note) => note((key) => overrideLabel(overrides, key)));
}
